export default "__VITE_ASSET__647f014d__"